// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.debug-overlay-module__overlay___T6rCP {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(49, 88, 94, 0.8);
  z-index: 9999;
  height: 300px;
  padding: 10px;
  font-family: "Courier New", Courier, monospace;
  display: flex;
  flex-direction: column;
  cursor: grab;
}
.debug-overlay-module__overlay___T6rCP input:not([type=checkbox]),
.debug-overlay-module__overlay___T6rCP button {
  height: 20px;
}

.debug-overlay-module__header___d9ze8 {
  display: flex;
  justify-content: space-between;
}
.debug-overlay-module__header___d9ze8 h2 {
  color: whitesmoke;
}

.debug-overlay-module__content___T_tPF {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
  flex-wrap: wrap;
}

.debug-overlay-module__storagePanel___TapH2,
.debug-overlay-module__actionsPanel___ybFXR,
.debug-overlay-module__copyPanel___BolAy,
.debug-overlay-module__errorTestingPanel___kr8q4 {
  flex: 1;
  min-width: 200px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
  position: relative;
  padding-top: 10px;
}

.debug-overlay-module__storagePanel___TapH2 {
  flex: 0.4;
}

.debug-overlay-module__errorTestingPanel___kr8q4 {
  min-width: 220px;
}

.debug-overlay-module__cookiePanelDiv___HMbxB {
  margin-top: 20px;
}

.debug-overlay-module__storagePanel___TapH2 h3,
.debug-overlay-module__actionsPanel___ybFXR h3,
.debug-overlay-module__copyPanel___BolAy h3,
.debug-overlay-module__errorTestingPanel___kr8q4 h3 {
  left: 10px;
  margin: 0;
}

.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__actionColumn___ji5yQ {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__actionColumn___ji5yQ button {
  text-align: left;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__tokenSelect___l3OBV {
  width: 30%;
  height: 22px;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__ottInput___rZgwe {
  display: flex;
  flex-direction: row;
  margin-bottom: 10px;
  justify-content: space-between;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__ottInput___rZgwe input {
  flex: 2;
  width: 100%;
  margin-right: 10px;
}
.debug-overlay-module__actionsPanel___ybFXR .debug-overlay-module__ottInput___rZgwe button {
  flex: 1;
  width: 100px;
}

.debug-overlay-module__buttonRow___QOlIw {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
  gap: 10px;
}
.debug-overlay-module__buttonRow___QOlIw button {
  flex: 1;
}

.debug-overlay-module__copyPanel___BolAy ul {
  list-style: none;
  padding: 0;
}

.debug-overlay-module__copyPanel___BolAy li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  width: 100%;
  line-height: 1;
}

.debug-overlay-module__copyPanelButton___EJblD {
  margin-left: 10px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 50px;
}

.debug-overlay-module__copyPanel___BolAy button:disabled {
  cursor: not-allowed;
}

.debug-overlay-module__overlayButton___PrL3s {
  position: absolute;
  top: 6px;
  left: 20%;
  padding: 10px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  border-radius: 50%;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease, transform 0.2s ease;
  z-index: 10000;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}

.debug-overlay-module__datadogButton___hVbKB {
  margin: 0;
  margin-top: 10px;
  padding: 0;
}

.debug-overlay-module__errorTestingPanel___kr8q4 .debug-overlay-module__errorInputSection___cTjov {
  margin-bottom: 15px;
}
.debug-overlay-module__errorTestingPanel___kr8q4 .debug-overlay-module__errorInputSection___cTjov label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  font-size: 12px;
}
.debug-overlay-module__errorTestingPanel___kr8q4 .debug-overlay-module__errorTestButton___G5G1Z {
  font-size: 12px;
  padding: 5px 10px;
  transition: all 0.2s ease;
}
.debug-overlay-module__errorTestingPanel___kr8q4 .debug-overlay-module__errorTestButton___G5G1Z:hover {
  background-color: #e0e0e0;
}
.debug-overlay-module__errorTestingPanel___kr8q4 .debug-overlay-module__errorTestInfo___ai4dH {
  margin-top: 10px;
  padding: 8px;
  background-color: #f0f0f0;
  border-radius: 3px;
  border-left: 3px solid #007bff;
}
.debug-overlay-module__errorTestingPanel___kr8q4 .debug-overlay-module__errorTestInfo___ai4dH small {
  line-height: 1.4;
  color: #555;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/debug-overlay/debug-overlay.module.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,uCAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAMF;AAJE;;EAEE,YAAA;AAMJ;;AAFA;EACE,aAAA;EACA,8BAAA;AAKF;AAJE;EACE,iBAAA;AAMJ;;AAFA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,0BAAA;EACA,iBAAA;EACA,eAAA;AAKF;;AAFA;;;;EAIE,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAKF;;AAFA;EACE,SAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAFA;EACE,gBAAA;AAKF;;AAFA;;;;EAIE,UAAA;EACA,SAAA;AAKF;;AADE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAIJ;AAFI;EACE,gBAAA;AAIN;AAAE;EACE,UAAA;EACA,YAAA;AAEJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AACJ;AACI;EACE,OAAA;EACA,WAAA;EACA,kBAAA;AACN;AACI;EACE,OAAA;EACA,YAAA;AACN;;AAIA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;AADF;AAGE;EACE,OAAA;AADJ;;AAKA;EACE,gBAAA;EACA,UAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AAFF;;AAKA;EACE,iBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAFF;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wCAAA;EACA,2DACE;EAEF,cAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;AAJF;;AAOA;EACE,SAAA;EACA,gBAAA;EACA,UAAA;AAJF;;AAQE;EACE,mBAAA;AALJ;AAOI;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AALN;AASE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AAPJ;AASI;EACE,yBAAA;AAPN;AAWE;EACE,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,8BAAA;AATJ;AAWI;EACE,gBAAA;EACA,WAAA;AATN","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils.scss';\n\n.overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(49, 88, 94, 0.8);\n  z-index: 9999;\n  height: 300px;\n  padding: 10px;\n  font-family: 'Courier New', Courier, monospace;\n  display: flex;\n  flex-direction: column;\n  cursor: grab;\n\n  input:not([type='checkbox']),\n  button {\n    height: 20px;\n  }\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  h2 {\n    color: whitesmoke;\n  }\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  gap: 15px;\n  border-top: 1px solid #ccc;\n  padding-top: 10px;\n  flex-wrap: wrap;\n}\n\n.storagePanel,\n.actionsPanel,\n.copyPanel,\n.errorTestingPanel {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  position: relative;\n  padding-top: 10px;\n}\n\n.storagePanel {\n  flex: 0.4;\n}\n\n.errorTestingPanel {\n  min-width: 220px;\n}\n\n.cookiePanelDiv {\n  margin-top: 20px;\n}\n\n.storagePanel h3,\n.actionsPanel h3,\n.copyPanel h3,\n.errorTestingPanel h3 {\n  left: 10px;\n  margin: 0;\n}\n\n.actionsPanel {\n  .actionColumn {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 20px;\n\n    button {\n      text-align: left;\n    }\n  }\n\n  .tokenSelect {\n    width: 30%;\n    height: 22px; // the other inputs are 20px, but  select doesn't line up and seems 2 px smaller\n  }\n\n  .ottInput {\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 10px;\n    justify-content: space-between;\n\n    input {\n      flex: 2;\n      width: 100%;\n      margin-right: 10px;\n    }\n    button {\n      flex: 1;\n      width: 100px;\n    }\n  }\n}\n\n.buttonRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 5px;\n  gap: 10px;\n\n  button {\n    flex: 1;\n  }\n}\n\n.copyPanel ul {\n  list-style: none;\n  padding: 0;\n}\n\n.copyPanel li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  width: 100%;\n  line-height: 1;\n}\n\n.copyPanelButton {\n  margin-left: 10px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 50px;\n}\n\n.copyPanel button:disabled {\n  cursor: not-allowed;\n}\n\n.overlayButton {\n  position: absolute;\n  top: 6px;\n  left: 20%;\n  padding: 10px;\n  cursor: pointer;\n  font-size: 16px;\n  color: #333;\n  border-radius: 50%;\n  min-width: 40px;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  transition:\n    background-color 0.3s ease,\n    transform 0.2s ease;\n  z-index: 10000;\n  user-select: none;\n}\n\n.datadogButton {\n  margin: 0;\n  margin-top: 10px;\n  padding: 0;\n}\n\n.errorTestingPanel {\n  .errorInputSection {\n    margin-bottom: 15px;\n\n    label {\n      display: block;\n      margin-bottom: 5px;\n      font-weight: bold;\n      font-size: 12px;\n    }\n  }\n\n  .errorTestButton {\n    font-size: 12px;\n    padding: 5px 10px;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #e0e0e0;\n    }\n  }\n\n  .errorTestInfo {\n    margin-top: 10px;\n    padding: 8px;\n    background-color: #f0f0f0;\n    border-radius: 3px;\n    border-left: 3px solid #007bff;\n\n    small {\n      line-height: 1.4;\n      color: #555;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `debug-overlay-module__overlay___T6rCP`,
	"header": `debug-overlay-module__header___d9ze8`,
	"content": `debug-overlay-module__content___T_tPF`,
	"storagePanel": `debug-overlay-module__storagePanel___TapH2`,
	"actionsPanel": `debug-overlay-module__actionsPanel___ybFXR`,
	"copyPanel": `debug-overlay-module__copyPanel___BolAy`,
	"errorTestingPanel": `debug-overlay-module__errorTestingPanel___kr8q4`,
	"cookiePanelDiv": `debug-overlay-module__cookiePanelDiv___HMbxB`,
	"actionColumn": `debug-overlay-module__actionColumn___ji5yQ`,
	"tokenSelect": `debug-overlay-module__tokenSelect___l3OBV`,
	"ottInput": `debug-overlay-module__ottInput___rZgwe`,
	"buttonRow": `debug-overlay-module__buttonRow___QOlIw`,
	"copyPanelButton": `debug-overlay-module__copyPanelButton___EJblD`,
	"overlayButton": `debug-overlay-module__overlayButton___PrL3s`,
	"datadogButton": `debug-overlay-module__datadogButton___hVbKB`,
	"errorInputSection": `debug-overlay-module__errorInputSection___cTjov`,
	"errorTestButton": `debug-overlay-module__errorTestButton___G5G1Z`,
	"errorTestInfo": `debug-overlay-module__errorTestInfo___ai4dH`
};
export default ___CSS_LOADER_EXPORT___;
